import React, { useEffect, useState } from "react";

const LicenseExpiryAlert: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [licenseMsg, setLicenseMsg] = useState("");

    useEffect(() => {

        const isLicenseExpired =
            sessionStorage.getItem("isLicenseExpired") === "true";

        const message =
            sessionStorage.getItem("licenseExpiredMsg") || "";

        setIsVisible(isLicenseExpired);
        setLicenseMsg(message);
    }, []);

    const dismiss = () => {
        sessionStorage.removeItem("isLicenseExpired");
        setIsVisible(false);
    };

    if (!isVisible) {
        return null;
    }

    return (
  <div
    className="license-expiry-alert alert bg-danger border-0 rounded-0 m-0 d-flex align-items-center text-white p-2"
    role="alert"
  >
    <i
      data-feather="alert-triangle"
      className="me-2 ri-alert-line fs-18"
    />

    <div
      className="flex-grow-1 text-truncate fs-15"
      dangerouslySetInnerHTML={{ __html: licenseMsg }}
    />

    <div className="flex-shrink-0">
      <button
        type="button"
        className="text-reset text-decoration-underline border-0 bg-transparent p-0"
        onClick={dismiss}
      >
        <b>Dismiss</b>
      </button>
    </div>
  </div>
);
};

export default LicenseExpiryAlert;
